import React from 'react';
import {InputLabel} from 'material-ui';
import SimpleEditor from '../editor/simple_editor';

export const SimpleEditorField = (field) => {

    let touched = field.meta.touched;
    let error = field.meta.error;

    return (
        <div>
            <InputLabel className="simpleEditorLabel">{field.label}</InputLabel>
            <SimpleEditor
                initialValue={field.input.value}
                onChange={htmlBody => {
                    field.input.onChange(htmlBody)
                }}
            />
            {touched && error && <span className="errMsg"> {error} </span>}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/fields/field_simple_editor.js